export default {
  all: [
    [
      {
        display: 'header',
        title: 'The All Deals analytics are going to launch soon.'
      }
    ]
  ],
  pma: [
    [
      {
        parameterName: 'PMA-52',
        plot: [
          ['max', 'Highest', { opacity: 0.2 }],
          ['average', 'Average'],
          ['min', 'Lowest', { opacity: 0.2 }]
        ],
        tickFormat: '$0a',
        displayName: 'Average deal value'
      },
      {
        parameterName: 'PMA-48',
        groupBy: 'PMA-48',
        displayName: 'Percentage of deals recommended',
        normalize: true,
        tickFormat: '0.0%',
        reorder: ['0', '4', '3', '2', '1', '5', '6', '7']
      },
      {
        parameterName: 'PMA-49',
        groupBy: 'PMA-49',
        displayName: 'Percentage of offers vs schemes',
        normalize: true,
        tickFormat: '0.0%'
      },
      {
        parameterName: 'PMA-52',
        groupBy: 'PMA-24',
        displayName: 'Type of bidder',
        normalize: true,
        tickFormat: '0.0%'
      },
      {
        parameterName: 'PMA-52',
        tickFormat: '$0a',
        plot: [
          ['sum', 'Total deal value']
        ],
        displayName: 'Total deal value'
      },
      {
        parameterName: 'PMA-105',
        plot: [
          ['max', 'Highest', { opacity: 0.3 }],
          ['average', 'Average'],
          ['min', 'Lowest', { opacity: 0.3 }]
        ],
        tickFormat: '%0.0',
        displayName: 'Average total fees as a % of deal (target)'
      },
      {
        parameterName: 'PMA-51',
        groupBy: 'PMA-51',
        displayName: 'Number of deals by consideration type'
      },
      {
        parameterName: 'PMA-57',
        groupBy: 'PMA-57',
        displayName: 'Number of deals by financing type'
      }
    ],
    [
      {
        parameterName: 'PMA-23',
        groupBy: 'PMA-23',
        displayName: 'Number of deals by industry sector'
      }
    ],
    [
      {
        parameterName: 'PMA-21',
        groupBy: 'PMA-21',
        displayName: 'Bidder location',
        display: 'map'
      }
    ]
  ],
  ipo: [
    [
      {
        parameterName: 'IPO-44',
        plot: [
          ['max', 'Highest', { opacity: 0.2 }],
          ['average', 'Average'],
          ['min', 'Lowest', { opacity: 0.2 }]
        ],
        tickFormat: '$0a',
        displayName: 'Average gross proceeds (of offer received by company)'
      },
      {
        parameterName: 'IPO-44',
        tickFormat: '$0a',
        plot: [
          ['sum', 'Total deal value']
        ],
        displayName: 'Total deal value (by gross proceeds)'
      },
      {
        parameterName: 'IPO-23',
        groupBy: 'IPO-23',
        tickFormat: '0',
        displayName: 'AIM vs Main Market IPO volume'
      },
      {
        parameterName: 'IPO-20',
        groupBy: 'IPO-20',
        tickFormat: '0',
        displayName: 'Number of deals by industry sector'
      },
      {
        parameterName: 'IPO-26',
        groupBy: 'IPO-26',
        tickFormat: '0',
        displayName: 'Main Market deals by listing category'
      },
      {
        parameterName: 'IPO-136',
        groupBy: 'IPO-136',
        labelFormat: (t) => `${(+t).toFixed(0)} days`,
        displayName: 'Average lock up period for company'
      },
      {
        parameterName: 'IPO-137',
        groupBy: 'IPO-137',
        tickFormat: '0',
        labelFormat: (t) => `${(+t).toFixed(0)} days`,
        displayName: 'Average lock up period for key shareholders'
      },
      {
        parameterName: 'IPO-138',
        groupBy: 'IPO-138',
        labelFormat: (t) => `${(+t).toFixed(0)} days`,
        displayName: 'Average lock up period for directors'
      },
      {
        parameterName: 'IPO-139',
        groupBy: 'IPO-139',
        tickFormat: '0',
        labelFormat: (t) => `${(+t).toFixed(0)} days`,
        displayName: 'Average lock up period for senior managers'
      },
      {
        parameterName: 'IPO-19',
        groupBy: 'IPO-19',
        tickFormat: '0',
        displayName: 'Issuer location',
        display: 'map'
      }
    ]
  ],
  so: [
    [
      {
        parameterName: 'SO-39',
        plot: [
          ['max', 'Highest', { opacity: 0.2 }],
          ['average', 'Average'],
          ['min', 'Lowest', { opacity: 0.2 }]
        ],
        tickFormat: '$0a',
        displayName: 'Average gross proceeds (of offer received by company)'
      },
      {
        parameterName: 'SO-39',
        tickFormat: '$0a',
        plot: [
          ['sum', 'Total deal value']
        ],
        displayName: 'Total deal value (by gross proceeds)'
      },
      {
        parameterName: 'SO-23',
        groupBy: 'SO-23',
        displayName: 'Number of deals by industry sector'
      },
      {
        parameterName: 'SO-29',
        groupBy: 'SO-29',
        tickFormat: '0',
        displayName: 'Main Market deals by listing category'
      },
      {
        parameterName: 'SO-149',
        groupBy: 'SO-149',
        labelFormat: (t) => `${(+t).toFixed(0)} days`,
        displayName: 'Average lock up period for company'
      },
      {
        parameterName: 'SO-76',
        groupBy: 'SO-76',
        displayName: 'Number of deals by offer type',
        info: 'This graph records every structure used on a deal, so a ‘placing and open offer’ is recorded as both a ‘placing’ and an ‘open offer’ and a ‘firm placing and placing’ as a ‘firm placing’ and a ‘placing’.'
      },
      {
        parameterName: 'SO-76',
        groupBy: 'SO-76',
        displayName: 'Percentage of deals by offer type',
        normalize: true,
        tickFormat: '0.0%',
        info: 'This graph records every structure used on a deal, so a ‘placing and open offer’ is recorded as both a ‘placing’ and an ‘open offer’ and a ‘firm placing and placing’ as a ‘firm placing’ and a ‘placing’.'
      },
      {
        parameterName: 'SO-22',
        groupBy: 'SO-22',
        tickFormat: '0',
        displayName: 'Issuer location',
        display: 'map'
      }
    ]
  ]
}
